import React, { lazy, Suspense, useEffect } from 'react';
import './style.scss';
import { Route, Switch, useHistory } from 'react-router-dom';
import {
  HOME_PAGE,
  SIGNUP,
  VINAPHONE_PLUS,
  DICH_VU,
  TINH_NANG,
  SEARCH,
  INS,
  VIEW_PDF,
  VIEW_PDFPAGE,
  APP_REDIRECT,
  TTTB,
  CNTTTB,
} from 'global/routes';
import Header from 'pages/Header/Header';
import Footer from 'pages/Footer/Footer';
// import Ekyc from 'pages/Ekyc/Ekyc';
import { Loading, ScrollTop } from 'components';
import DownloadApp from 'components/DowloadApp/DownloadApp';
import $ from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import { UserService } from 'services/UserService';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import { doFCMToken } from 'store/action/userAction';

const HomePage = lazy(() => import('pages/HomePage/HomePage'));
const NotFoundPage = lazy(() => import('pages/NotFoundPage/NotFoundPage'));
const Signup = lazy(() => import('pages/Login/Component/Signup.js'));
const Service = lazy(() => import('pages/Service/Service'));
const ServiceDetail = lazy(() => import('pages/ServiceDetail/ServiceDetail'));
const Feature = lazy(() => import('pages/Feature/Feature'));
const SearchPage = lazy(() => import('pages/SearchPage/SearchPage'));
const Version = lazy(() => import('pages/Version/Version'));
const VnptPay = lazy(() => import('pages/VnptPay/VnptPay'));
const ReturnCTT = lazy(() => import('pages/ReturnCTT/ReturnCTT'));
const Ekyc = lazy(() => import('pages/Ekyc/Ekyc'));
const EkycWithoutLogin = lazy(() => import('pages/Ekyc/EkycWithoutLogin'));
const AppDeepLink = lazy(() => import('pages/AppDeepLink/AppDeepLink'));
const Introduce = lazy(() => import('pages/Introduce/Introduce'));
const PreviewPdf = lazy(() => import('pages/ViewFiles/PreviewPdf'));
const PreviewHTML = lazy(() => import('pages/ViewFiles/PreviewHTML'));
const VinaphonePlusNew = lazy(() => import('pages/VinaphonePlusNew/VinaphonePlusNew'));

const UpdateUserInfo = lazy(() => import('pages/TTTB/UpdateUserInfo'));

const UpdateInfoWithoutLogin = lazy(() => import('pages/TTTB/UpdateInfoWithoutLogin'));
const RedirectCTT = lazy(() => import('pages/VnptPay/RedirectCTT/RedirectCTT'));

export default function MainPage() {

  const dispatch = useDispatch();
  const authorized = useSelector(state => state.authorizedReducer.authorized);
  const history = useHistory();
  const isApp = useSelector((state) => state.deviceReducer.isApp);

  useEffect(() => {
    const lat = localStorage.getItem('lat');
    const currentUrl = window.location.href;
    const excludedPaths = [
      "/vnptpay-ctt/return",
      "/thanhtoan/roaming",
      "isApp=1"
    ];
    if (!lat && !excludedPaths.some(path => currentUrl.includes(path))) {
      getCurrentLocate();
    }
    const url = new URL(window.location.href);
    const sub_id = url.searchParams.get('sub_id');
    if (!sub_id && history.location.pathname !== INS) {
      // showChat(); //remove ami
    }
    window.addEventListener('error', () => {
      // if (window.location?.hostname === 'my.vnpt.com.vn') {
      //   window.location.href = `${window.location.origin}/not-found`;
      // }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    try {
      if(!currentUrl.includes('/vnptpay-ctt/return') && !currentUrl.includes('/thanhtoan/roaming')) {
        askNotiPermission();
      }
      // TODO: Replace the following with your app's Firebase project configuration
      // See: https://firebase.google.com/docs/web/learn-more#config-object
      const firebaseConfig = {
        apiKey: 'AIzaSyD5kkyTX_ioGcp49QoZJQq9T5EwPLkRCkI',
        authDomain: 'myvnpt-2018-10ace.firebaseapp.com',
        // The value of `databaseURL` depends on the location of the database
        databaseURL: 'https://myvnpt-2018-10ace.firebaseio.com',
        projectId: 'myvnpt-2018-10ace',
        storageBucket: 'myvnpt-2018-10ace.appspot.com',
        messagingSenderId: '19170414058',
        appId: '1:19170414058:ios:90f6e06a3cef7023',
        // ...
      };
      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      // Initialize Firebase Cloud Messaging and get a reference to the service
      const messaging = getMessaging(app);
      // Get Token from Firebase
      getToken(messaging, { vapidKey: 'BAbAmVZ86mYkfqP8jo-vj7-lned7nLqOM_J6djJg4nYVSIzvDz0n4V4BD3Z2ZFMrtfpdmBQx78HIB13GBBqpxFs' }).then((currentToken) => {
        if (currentToken) {
          dispatch(doFCMToken(currentToken));
          // Send the token to your server and update the UI if necessary
          // ...
        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
          // ...
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
        // ...
      });
    } catch (error) {
      console.log('An error occurred. ', error);
    }
  }, []);

  useEffect(() => {
    if (authorized && history.location.pathname != TTTB) {

      getInfoCustom();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorized]);

  const getInfoCustom = () => {
    const data = {
      msisdn: localStorage.getItem('mobile'),
    };

    UserService.getInfoCustom(data, res => {
      if (res.error_code === '0') {
        localStorage.setItem('fullName', res.result.FULL_NAME);
        localStorage.setItem('cust_id', res.result.CUSTOMER_ID);
        dispatch({
          type: 'ADD_USER_INFO',
          payload: res.result,
        });
      }
    });
  };

  const showChat = () => {
    window.$ = $;
    const s = document.createElement('script');
    s.async = true;
    s.dataSkipMoving = true;
    s.src = `https://ipcc.vnpt.com.vn/upload/crm/site_button/loader_9_24jn9r.js?${Date.now() / 60000 | 0}`;
    const h = document.getElementsByTagName('script')[0];
    h.parentNode.insertBefore(s, h);
    document.body.appendChild(s);

    return () => {
      document.body.removeChild(s);
    };
  };

  const getCurrentLocate = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    }
  };

  const askNotiPermission = () => {
    Notification.requestPermission();
  };

  const showPosition = (position) => {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;
    localStorage.setItem('lat', lat);
    localStorage.setItem('lng', lng);
  };

  return (
    <div className="app-wrapper">
      {isApp != 1 && <Header />}
      <div className="main-page">
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route
              exact
              path={HOME_PAGE}
              component={HomePage}
            />
            <Route
              exact
              path={HOME_PAGE}
              component={HomePage}
            />
            <Route
              exact
              path={DICH_VU}
              component={Service}
            />
            <Route
              path={SIGNUP}
              exact
              component={Signup}
            />
            <Route
              path="/version"
              exact
              component={Version}
            />
            <Route
              path="/ekyc"
              exact
              component={Ekyc}
            />
            <Route
              path={APP_REDIRECT}
              exact
              component={AppDeepLink}
            />
            <Route
              path={TTTB}
              exact
              component={UpdateUserInfo}
            />
            <Route
              path={CNTTTB}
              exact
              component={UpdateInfoWithoutLogin}
            />
            <Route
              path="/ekyc_tttb"
              exact
              component={EkycWithoutLogin}
            />
            <Route
              path={INS}
              exact
              component={Introduce}
            />
            <Route
              path="/vnptpay/:slug"
              exact
              component={VnptPay}
            />
            <Route
              path="/return_ctt"
              exact
              component={ReturnCTT}
            />
            <Route
              path="/vnptpay-ctt/return"
              exact
              component={RedirectCTT}
            />
            <Route
              path={`${VINAPHONE_PLUS}`}
              exact
              component={VinaphonePlusNew}
            />
            <Route
              path={`${VINAPHONE_PLUS}/:slug`}
              exact
              component={VinaphonePlusNew}
            />
            <Route
              path={`${SEARCH}/:slug`}
              exact
              component={SearchPage}
            />
            <Route
              path={`${DICH_VU}/:service`}
              component={ServiceDetail}
            />
            <Route
              path={`${TINH_NANG}/:service`}
              exact
              component={Feature}
            />
            <Route
              path={VIEW_PDF}
              exact
              component={PreviewPdf}
            />
            <Route
              path="*"
              component={NotFoundPage}
            />
          </Switch>
          {history.location.pathname !== INS && <DownloadApp />}
          <ScrollTop />
        </Suspense>
      </div>
      {isApp != 1 && <Footer />}
    </div>
  );
}
